const dayMs = 86400000;
const zeroSign = row => row.zeroRewardSign === true && Number(row.status) === 2 && Number(row.rewardAmount) === 0;
const deferredSign = row => ({ PENDING_CLAIM: 1, PENDING_REVIEW: 1, PENDING_DISPATCH: 1, REJECTED: 3 }[row.signRewardState] === Number(row.status) && Number(row.frozenSignAmount) > 0);
const validDate = value => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) && Number.isFinite(Date.parse(value + 'T00:00:00Z')) && new Date(value + 'T00:00:00Z').toISOString().slice(0, 10) === value;

// 日期仅用于只读月历，不据此判断签到资格。
export function signInHistoryToday(now = Date.now()) {
  return new Date(now + 8 * 3600000).toISOString().slice(0, 10);
}

export function signInHistoryMonthRange(month) {
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(month) || Number(month.slice(0, 4)) < 1000) throw new Error('月份无效');
  const [year, index] = month.split('-').map(Number);
  const start = Date.UTC(year, index - 1, 1);
  const end = Date.UTC(year, index, 0);
  return { start, end, startTime: month + '-01 00:00:00', endTime: new Date(end).toISOString().slice(0, 10) + ' 23:59:59' };
}

export function shiftSignInHistoryMonth(month, offset) {
  const { start } = signInHistoryMonthRange(month);
  const date = new Date(start);
  date.setUTCMonth(date.getUTCMonth() + offset);
  const result = date.toISOString().slice(0, 7);
  signInHistoryMonthRange(result);
  return result;
}

export function signInHistoryCells(month, records, { today, ready = true } = {}) {
  const { start, end } = signInHistoryMonthRange(month);
  const completed = records.filter(row => validDate(row.signDate) && (Number(row.status) === 1 || (Number(row.status) === 2 && Number(row.rewardAmount) > 0) || zeroSign(row) || deferredSign(row)));
  const signed = new Set(completed.map(row => row.signDate));
  const repaired = new Set(completed.filter(row => row.repairSign === true).map(row => row.signDate));
  const leading = (new Date(start).getUTCDay() + 6) % 7;
  const length = Math.round((end - start) / dayMs) + 1;
  return Array.from({ length: Math.ceil((leading + length) / 7) * 7 }, (_, index) => {
    const day = index - leading + 1;
    if (day < 1 || day > length) return { key: 'blank-' + index, blank: true };
    const date = new Date(start + (day - 1) * dayMs).toISOString().slice(0, 10);
    const kind = !ready ? 'unknown' : signed.has(date) && date <= today ? repaired.has(date) ? 'repaired' : 'signed' : date > today ? 'future' : 'missed';
    return { key: date, date, day, kind, today: date === today, status: { unknown: '待查询', signed: '已签到', repaired: '已补签', future: '未到日期', missed: '未签到' }[kind] };
  });
}

// 明细中的待领取不是到账；金额优先使用实际入账额或服务端冻结的待领取额。
export function signInHistoryRewards(month, records, pendingStatus = null) {
  return records.filter(row => validDate(row.signDate) && row.signDate.startsWith(month + '-')).map(row => {
    const paid = Number(row.status) === 2 && Number(row.rewardAmount) > 0;
    const registered = zeroSign(row);
    const pending = Number(row.status) === 1;
    const repair = pendingStatus?.repairDays?.find(day => String(day.recordId) === String(row.id) && day.date === row.signDate);
    const frozen = pending && String(row.id) === String(pendingStatus?.pendingRecordId) ? pendingStatus?.nextReward : repair?.rewardAmount;
    const amount = paid || registered ? String(row.rewardAmount) : deferredSign(row) ? String(row.frozenSignAmount) : pending && Number(frozen) > 0 ? String(frozen) : '—';
    return { id: row.id, date: row.signDate, repairSign: row.repairSign === true, amount, kind: paid ? 'paid' : registered ? 'registered' : pending ? 'pending' : 'other', status: paid ? '已到账' : registered ? '已签到（无彩金）' : deferredSign(row) ? ({ PENDING_CLAIM: '待领取', PENDING_REVIEW: '待审核', PENDING_DISPATCH: '审核通过，待发放', REJECTED: '已签到（审核拒绝）' }[row.signRewardState]) : pending ? '待领取' : Number(row.status) === 3 ? '未通过' : '待确认' };
  }).sort((a, b) => b.date.localeCompare(a.date));
}
